export default __webpack_public_path__ + "static/media/043-surgeon fish.31400b8b.svg";